/**************************************************
 * Nombre:       Dashboard
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Alert, Grid2, Slide, Snackbar} from "@mui/material";
import DashboardBase from "../Modulo_Dashboard/Componentes/DashboardBase";
import React, {createContext, useState} from "react";
import {
    ArticleOutlined,
    BadgeOutlined,
    HandshakeOutlined,
    LayersOutlined,
    Notifications,
    WarningAmberOutlined
} from "@mui/icons-material";
import {funSalir} from "../Servicios/Auth/funSalir";
import Seccion_Adicional from "./Secciones/Seccion_Adicional";
import Seccion_Documentos from "./Secciones/Seccion_Documentos";
import Seccion_Pqrs from "./Secciones/Seccion_Pqrs";
import Seccion_Usuarios from "./Secciones/Seccion_Usuarios";
import Seccion_Proyectos from "./Secciones/Seccion_Proyectos";


export const contexBarra = createContext()
const Dashboard = () => {
    const [notificaciones, setNotificaciones] = useState([])
    const [nuevasNotificaciones, setNuevasNotificaciones] = useState(0)
    const [historial, setHistorial] = useState([])
    const [nuevoHistorial, setNuevoHistorial] = useState(0)

    const [open, setOpen] = useState(false)
    const salir = () => {
        funSalir()
    }

    const valoresBarra = {
        notificaciones,
        nuevasNotificaciones,
        historial,
        nuevoHistorial,
        funSalir: salir

    }


    const {Provider} = contexBarra;


    return (
        <Grid2
            container
            size={12}
        >


            <Provider value={valoresBarra}>
                <DashboardBase secciones={secciones} seccionesPerfil={seccionesPerfil} seccionesID={seccionesID}/>
            </Provider>

            <Snackbar
                open={open}
                autoHideDuration={3000}
                onClose={() => setOpen(false)}
                anchorOrigin={{vertical: 'top', horizontal: 'right'}}
                TransitionComponent={Slide}
                //action={action}
                role={'alert'}
                disableWindowBlurListener={true}

            >
                <Alert
                    icon={<Notifications fontSize="inherit"/>}
                    onClose={() => setOpen(false)}
                    severity={'secondary'}
                    variant={'filled'}
                    sx={{width: '100%'}}
                >
                    {'Notificaciones Encendidas'}
                </Alert>
            </Snackbar>

        </Grid2>
    )

}
export default Dashboard

const secciones = [
    {
        nombre: 'Proyectos',
        icono: HandshakeOutlined,
        camino: '/Proyectos',
        categoria: 'Pagina',
        Componente: <Seccion_Proyectos/>
    },
    {
        nombre: 'Documentos',
        icono: ArticleOutlined,
        camino: '/Documentos',
        categoria: 'Pagina',
        Componente: <Seccion_Documentos/>
    },
    {
        nombre: 'Adicionales',
        icono: LayersOutlined,
        camino: '/Adicionales',
        categoria: 'Pagina',
        Componente: <Seccion_Adicional/>
    },
    {
        nombre: 'Pqrs',
        icono: WarningAmberOutlined,
        camino: '/Pqrs',
        categoria: 'Pagina',
        Componente: <Seccion_Pqrs/>
    },
    {
        nombre: 'Usuarios',
        icono: BadgeOutlined,
        camino: '/Usuarios',
        categoria: 'Accesos',
        Componente: <Seccion_Usuarios/>
    }


]

const seccionesID = []

const seccionesPerfil = []

const notificaciones = {}